













































import Vue from 'vue'
import {RawQuest, QuestResult, Anscnt} from '@/types/entity/RawPoll'
// @ts-ignore
import VcPiechart from 'vc-piechart'
import 'vc-piechart/dist/lib/vc-piechart.min.css'
const COLORS = [
  '#FA8953',
  '#E6E6E6',
  '#3DC66D',
  '#606266',
  '#DC3737',
  '#DC8A37',
  '#DCDC37',
  '#8ADC37',
  '#37DC37',
  '#37DC8A',
  '#37DCDC',
  '#378ADC',
  '#3737DC',
  '#8A37DC',
  '#DC37DC',
  '#DC378A'
]
interface IAnswer {label: string, value: number, ctn: number, color?: string}
interface ISection {label: string, value: number, color?: string}
export default Vue.extend({
  props: {
    quest: {} as () => RawQuest,
    anscnt: {} as () => Anscnt[] | undefined,
    index: Number
  },
  components: {
    VcPiechart
  },
  data () {
    return {
      checkedColors: [] as number[],
      lastColorIndex: -1,
      total: 0
    }
  },
  methods: {
    getColor (): string {
      let color = '#E6E6E6'
      if (this.lastColorIndex <= COLORS.length) {
        color = COLORS[this.lastColorIndex + 1]
        this.lastColorIndex++
      }
      return color;
    },
    getValue (ctn: number): number {
      return Math.round((ctn / this.total) * 100)
    },
    getAnscnt (ans: string): Anscnt | undefined {
      if (this.anscnt) {
        return this.anscnt.find(anscnt => anscnt.ans === ans);
      }
    }
  },
  computed: {
    answers (): IAnswer[] {
      let answers: IAnswer[] = []
      this.lastColorIndex = -1;
      if (this.anscnt) {
        let total = 0;
        for (const anscnt of this.anscnt) {
          total += anscnt.cnt
        }
        this.total = total;

        for (const item of this.quest.items) {
          let anscnt = this.getAnscnt(item.text);
          let section: IAnswer = {
            label: item.text,
            value: anscnt && this.getValue(anscnt.cnt) || 0,
            ctn: anscnt && anscnt.cnt || 0,
            color: this.getColor()
          }
          answers.push(section)
        }
      }
      return answers;
    },
    sections (): ISection[] {
      let sections: ISection[] = []
      for (const answer of this.answers) {
        if (answer.value) {
          let section: ISection = {
            label: answer.label,
            value: Math.ceil(answer.value),
            color: answer.color
          }
          sections.push(section)
        }
      }
      // if (sections.length) {
      //   let sum = 0;
      //   for (const sect of sections) {
      //     sum += sect.value;
      //   }
      //   if (sum !== 100) {
      //     let diff = 100 - sum;
      //     sections[sections.length - 1].value = sections[sections.length - 1].value + diff
      //   }
      // }
      return sections;
    }
  }
})
